import { sdk } from '@/lib/config';
import { Customer } from '@/types/userTypes';
import { StoreOrder } from '@medusajs/types';
import { create } from 'zustand';

type UserStoreType = {
  current_user: Customer | null;
  orders: StoreOrder[] | null;
  setUser: (user: Customer | null) => void;
  setOrders: (orders: StoreOrder[] | null) => void;
  fetchUser: () => void;
  fetchOrders: () => void;
};

const useAuth = create<UserStoreType>((set) => ({
  current_user: null,
  orders: null,
  setUser: (user: Customer | null) => {
    set({
      current_user: user,
    });
  },
  setOrders: (orders: StoreOrder[] | null) => {
    set({
      orders: orders,
    });
  },
  fetchUser: async () => {
    try {
      const { customer } = await sdk.store.customer.retrieve();
      set({
        current_user: customer || null,
      });
    } catch (error: any) {
      if (error.message === 'Unauthorized' || error.name === 'FetchError') {
        set({
          current_user: null,
        });
      } else {
        console.log('Unexpected fetch user error:', error);
        set({
          current_user: null,
        });
      }
    }
  },
  fetchOrders: async () => {
    try {
      const { orders } = await sdk.store.order.list({
        fields:
          '+shipping_address.first_name,+shipping_address.last_name,+shipping_address.phone, +shipping_address.address_1,+shipping_address.address_2',
      });
      set({
        orders: orders,
      });
    } catch (error) {
      console.log(error);
    }
  },
}));

export { useAuth };
